import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import AgeGate from './AgeGate';
import CookieConsent from './CookieConsent';
import MobileProfileSidebar from './MobileProfileSidebar';
import QuickAccessMenu from './QuickAccessMenu';
import { useAuth } from '../../context/UseAuth';

function MainLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAgeGateVisible, setIsAgeGateVisible] = useState(false);
  const [isQuickMenuOpen, setIsQuickMenuOpen] = useState(false);

  const { user, isAuthenticated } = useAuth(); // Usamos isAuthenticated para una comprobación más fiable
  const isCreator = user?.profileType === 'creator';

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const toggleQuickMenu = () => setIsQuickMenuOpen((prev) => !prev);

  const handleAgeGateVisibility = useCallback((isVisible) => {
    setIsAgeGateVisible(isVisible);
  }, []);

  const handleToggleSidebar = () => {
    if (!isSidebarOpen) {
      setIsQuickMenuOpen(false);
    }
    toggleSidebar();
  };

  return (
    <>
      <AgeGate onVisibilityChange={handleAgeGateVisibility} />

      <div
        className={`relative min-h-screen flex ${
          isAgeGateVisible ? 'blur-md pointer-events-none' : ''
        }`}
      >
        {/* ===== SIDEBAR ESCRITORIO (CORREGIDO) ===== */}
        {/* Se añade lg:block para asegurar que sea visible en desktop */}
        <div className="hidden lg:block lg:sticky lg:top-0 lg:h-screen lg:w-64">
          <Sidebar />
        </div>

        {/* MENÚ HAMBURGUESA MÓVIL (lógica existente) */}
        {isAuthenticated && (
          <>
            <div
              aria-hidden="true"
              className={`fixed inset-0 z-30 bg-black/60 lg:hidden ${
                isSidebarOpen ? 'block' : 'hidden'
              }`}
              onClick={handleToggleSidebar}
            />
            <div
              className={`fixed top-0 left-0 z-40 h-screen transition-transform duration-300 ease-in-out lg:hidden ${
                isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
              }`}
            >
              <Sidebar onLinkClick={() => setIsSidebarOpen(false)} />
            </div>
          </>
        )}

        <div className="relative flex min-w-0 flex-1 flex-col">
          <Navbar onToggleSidebar={handleToggleSidebar} />
          <main className="flex-1 pb-24 lg:pb-0">
            <Outlet />
          </main>
          <Footer />
        </div>
      </div>

      {/* ===== COMPONENTES DE UI MÓVIL (CORREGIDO) ===== */}
      {/* Se renderizan solo si el usuario está autenticado */}
      {isAuthenticated && (
        <>
          <MobileProfileSidebar onToggleQuickMenu={toggleQuickMenu} />
          {isCreator && (
            <QuickAccessMenu
              isOpen={isQuickMenuOpen}
              setIsOpen={setIsQuickMenuOpen}
            />
          )}
        </>
      )}

      <CookieConsent />
    </>
  );
}

export default MainLayout;
